module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./UsageDetailsView.js"));
	}, "UsageDetailsView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=UsageDetailsView!./src/pages/Shop/Member/Wallet/Coupon/UsageDetails/UsageDetailsView.js
// module id = 1079
// module chunks = 438